module.exports = __webpack_public_path__ + "img/credential-2.6474dc58.png";